import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { createTask, getAllTaskList, taskDetail, updateTask } from '@blade-sxp/task-management/api/statistics/index';
import { queryDeviceRtspPreviewAddress, getDeviceRegion } from '@blade-sxp/task-management/api/creat-task/index';
import cascaderSelect from '@blade/common/components/device-cascader-select/index.vue';
import moment from 'moment';
import RoiArea from '@blade-sxp/task-management/components/roi-area.vue';
import TabArea from '@blade-sxp/task-management/components/tab-area.vue';
import { cloneDeep, compact, isEmpty } from 'lodash';
import { createTaskParams } from '@blade-sxp/task-management/api/creat-task/create-task-params';
import { setCustomOptions } from '@blade-sxp/task-management/constant/drawer-options';
import { Message } from 'element-ui';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
const Service = { createTask, queryDeviceRtspPreviewAddress };
let createStaffDutyLeaveTask = class createStaffDutyLeaveTask extends Vue {
    dataSource = [];
    shouldReset = false;
    twinRoi = {};
    drawButtons = ['polygon', 'rect'];
    typeStyle = 'add';
    rtspUrl = '';
    isPlayFlag = false;
    disableSlectValue = true;
    radio = '';
    directionConfig = {};
    tabData = [
        { name: `${this.$t('roiArea')}`, id: 1, type: 'roiArea', roiType: 'polygon', complete: false },
        { name: `${this.$t('markOnMap')}`, id: 3, type: 'markOnMap', roiType: 'polygon', complete: false },
    ];
    zoneList = {
        vertices: [],
        id: '',
        name: '',
    };
    taskStatus = 'ENABLE';
    formData = {
        leaveDuration: 5,
        dateTime: [''],
        slectValue: '',
        radio: '',
        isEdit: false,
        changeRoi: false,
        deviceId: '',
        taskName: '',
        taskStatus: 'ENABLE',
        thresholdSet: {
            leaveTime: 0,
            workHours: [{ start: '', end: '' }],
        },
        device: '',
        alertInterval: 10,
        alertNotification: {
            critical: { level: '', value: '400' },
            major: { level: '', value: '300' },
            minor: { level: '', value: '200' },
        },
        remark: '',
    };
    submitParams = cloneDeep(createTaskParams);
    crossLineDetail = [];
    slectValue = '';
    value1 = '';
    tabbarData = [
        {
            value: 'roiArea',
            label: 'roiArea',
        },
        {
            value: 'bodyFrame',
            label: 'bodyFrame',
        },
    ];
    notificationOption = [
        {
            value: 'critical',
            label: 'critical',
        },
        {
            value: 'major',
            label: 'major',
        },
        {
            value: 'minor',
            label: 'minor',
        },
    ];
    isSave = false;
    activeName = 'roiArea';
    maxTimeSlot = 5;
    drawState = false;
    shouldFirst = 1;
    zoneId = '';
    polygons = [];
    optionsSelect = [];
    paintState = false;
    deviceId = 0;
    options = setCustomOptions('polygon');
    isError = false;
    isDisabled = false;
    // 校验正整数
    positiveInt(value) {
        const reg = /^[1-9]\d*$/;
        return reg.test(value);
    }
    // formData rules
    get rules() {
        return {
            taskName: [{ required: true, message: this.$t('taskNameErr'), trigger: 'blur' }],
            leaveDuration: [
                { required: true, message: `${this.$t('positiveInteger')}`, trigger: 'blur' },
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!this.positiveInt(value)) {
                            callback(new Error(`${this.$t('positiveInteger')}`));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
            alertInterval: [
                { required: true, message: `${this.$t('positiveInteger')}`, trigger: 'blur' },
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!this.positiveInt(value)) {
                            callback(new Error(`${this.$t('positiveInteger')}`));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
        };
    }
    // 判断按钮状态
    onChnageFormData(val) {
        // // 判断ROI完成状态
        if (this.typeStyle === 'edit') {
            this.shouldFirst++;
            if (this.shouldFirst === 2) {
                this.isSave = true;
                return;
            }
        }
        let result = this.tabData.every((item) => item.complete === true);
        if (val.dateTime.length === 0 || val.dateTime[0] === '') {
            this.isSave = true;
            return;
        }
        if (val.isEdit) {
            if (val.taskName && result && val.alertInterval && val.leaveDuration && val.radio) {
                this.isSave = false;
            }
            else {
                this.isSave = true;
            }
        }
        else {
            if (val.taskName && result && val.alertInterval && val.leaveDuration) {
                this.isSave = false;
            }
            else {
                this.isSave = true;
            }
        }
    }
    deviceIdChange(val) {
        if (val) {
            this.deviceId = val;
            this.getRtsp(val);
        }
        else {
            this.clearRoi();
            this.disableSlectValue = true;
            this.rtspUrl = '';
        }
    }
    // private editBtn() {
    //   const url = this.$route.path;
    //   const { id, taskType } = this.$route.query;
    //   this.$router.push({ path: url, query: { type: 'update', taskType, id } });
    //   this.isDisabled = false;
    // }
    returnSubmit() {
        this.$router.push('/tasklist');
    }
    getDeviceRegion(deviceId, rtspUrl) {
        getDeviceRegion(deviceId).then((res) => {
            if (!res.hasLinkedMap) {
                this.$alert(`${this.$t('hasLinkedMap', { camera: res.name })}`, `${this.$t('tip')}`, {
                    confirmButtonText: `${this.$t('know')}`,
                    confirmButtonClass: 'confirm-roi-tip',
                });
                this.formData.deviceId = '';
                return;
            }
            if (res.zoneStatus !== 'ENABLE') {
                this.$alert(`${this.$t('status', { camera: res.name })}`, `${this.$t('tip')}`, {
                    confirmButtonText: `${this.$t('know')}`,
                    confirmButtonClass: 'confirm-roi-tip',
                });
                this.formData.deviceId = '';
                return;
            }
            if (!res.hasUploadedMap) {
                this.$alert(`${this.$t('hasUploadedMap', { camera: res.name })}`, `${this.$t('tip')}`, {
                    confirmButtonText: `${this.$t('know')}`,
                    confirmButtonClass: 'confirm-roi-tip',
                });
                this.formData.deviceId = '';
                return;
            }
            if (isEmpty(res.vertices)) {
                this.$alert(`${res.name} ${this.$t('noVertices')}`, `${this.$t('tip')}`, {
                    confirmButtonText: `${this.$t('know')}`,
                    confirmButtonClass: 'confirm-roi-tip',
                });
                this.formData.deviceId = '';
                return;
            }
            let param = {
                externalBizFrom: '',
                keyword: '',
                taskTypes: ['QUEUE'],
                zoneIds: [res.zoneId],
            };
            getAllTaskList(param).then((res) => {
                this.optionsSelect = res;
                this.disableSlectValue = false;
            });
            this.zoneId = res.zoneId;
            this.rtspUrl = rtspUrl;
        });
    }
    // 重置roi
    clearRoi() {
        for (let value of this.tabData) {
            value.complete = false;
        }
        this.formData.changeRoi = !this.formData.changeRoi;
        this.$refs.tabArea.goPrevious();
        this.dataSource = [];
        this.twinRoi = {};
    }
    setStartDraw(val) {
        this.paintState = val;
    }
    deleteRoiArea(id) {
        const dom = this.$refs.drawer;
        dom.$refs.simpleDrawer.deleteGraph(id);
    }
    handleDrawEnd(val) {
        this.paintState = false;
        this.polygons = val;
    }
    getRtsp(deviceId) {
        this.rtspUrl = '';
        if (this.shouldReset === true) {
            this.clearRoi();
        }
        Service.queryDeviceRtspPreviewAddress(String(deviceId)).then((resp) => {
            this.getDeviceRegion(deviceId, resp.rtspPreviewAddress);
            // this.rtspUrl = (resp as any).rtspPreviewAddress;
            this.shouldReset = true;
        });
    }
    startDraw() {
        this.drawState = true;
    }
    get pickerOptions() {
        return {
            shortcuts: [
                {
                    text: this.$t('week'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    },
                },
                {
                    text: this.$t('halfMonth'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                        picker.$emit('pick', [start, end]);
                    },
                },
            ],
            disabledDate: (date) => moment(date).subtract(1, 'days').isSameOrAfter(moment().format('YYYY-MM-DD')),
        };
    }
    // 添加时间段
    addTimeRange() {
        if (this.formData.dateTime.length === 3) {
            return;
        }
        this.formData.dateTime.push('');
    }
    // 移除当前时间段
    removeTimeRange(i) {
        this.formData.dateTime.splice(i, 1);
    }
    cancelSubmit() {
        this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
            confirmButtonText: `${this.$t('confirm')}`,
            cancelButtonText: `${this.$t('cancel')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            customClass: 'task-confirm',
        }).then(() => {
            localStorage.setItem('key', 'OFF_DUTY_DETECTION');
            this.$router.push('/tasklist');
        });
    }
    checkEdit(val) { }
    checkErr() {
        if (!this.formData.taskName) {
            Message.error(this.$t('taskNameErr'));
            return false;
        }
        if (!this.formData.deviceId) {
            Message.error(this.$t('radioErr'));
            return false;
        }
        if (this.formData.dateTime.length === 0) {
            Message.error(this.$t('timeLog'));
            return false;
        }
        if (!this.formData.radio && this.formData.isEdit) {
            Message.error(this.$t('radioErr'));
            return false;
        }
        return true;
    }
    saveMsg() {
        if (!this.checkErr()) {
            return;
        }
        this.submitParams.remark = this.formData.remark;
        this.submitParams.alarmConfig.enable = Boolean(this.formData.isEdit);
        this.submitParams.taskName = this.formData.taskName;
        this.submitParams.taskType = 'OFF_DUTY_DETECTION';
        this.submitParams.alarmConfig.thresholdConfigs[0].levelConfig.unit = 'ABSOLUTE';
        this.submitParams.bondTaskId = String(this.formData.slectValue);
        this.submitParams.alarmConfig.notifyConfig.frequency.unit = 'MINUTE';
        this.submitParams.alarmConfig.notifyConfig.frequency.value = this.formData.alertInterval;
        this.submitParams.deviceTaskConfigs[0].deviceId = this.formData.deviceId;
        this.submitParams.deviceTaskConfigs[0].zoneId = this.zoneId;
        this.submitParams.alarmConfig.thresholdConfigs[0].threshold.type = 'COUNTING';
        this.submitParams.alarmConfig.thresholdConfigs[0].threshold.unit = 'MINUTE';
        this.submitParams.alarmConfig.notifyConfig.enabledAlarmLevels = [];
        if (this.formData.radio === 'critical') {
            this.submitParams.alarmConfig.thresholdConfigs[0].levelConfig.critical = this.formData.leaveDuration;
            this.submitParams.alarmConfig.notifyConfig.enabledAlarmLevels.push('CRITICAL');
        }
        else if (this.formData.radio === 'major') {
            this.submitParams.alarmConfig.notifyConfig.enabledAlarmLevels.push('MAJOR');
            this.submitParams.alarmConfig.thresholdConfigs[0].levelConfig.major = this.formData.leaveDuration;
        }
        else if (this.formData.radio === 'minor') {
            this.submitParams.alarmConfig.notifyConfig.enabledAlarmLevels.push('MINOR');
            this.submitParams.alarmConfig.thresholdConfigs[0].levelConfig.minor = this.formData.leaveDuration;
        }
        this.submitParams.alarmConfig.notifyConfig.enabledAlarmLevels = compact(this.submitParams.alarmConfig.notifyConfig.enabledAlarmLevels);
        this.submitParams.taskStatus = this.formData.taskStatus;
        if (this.formData.dateTime.length > 0) {
            this.submitParams.alarmConfig.thresholdConfigs[0].effectiveTimes = [];
            for (let i in this.formData.dateTime) {
                let objItem = {
                    end: this.formData.dateTime[i][1],
                    start: this.formData.dateTime[i][0],
                };
                this.submitParams.alarmConfig.thresholdConfigs[0].effectiveTimes.push(objItem);
            }
        }
        Vue.delete(this.submitParams.alarmConfig.thresholdConfigs[0], 'effectiveDates');
        Vue.delete(this.submitParams.alarmConfig.thresholdConfigs[0], 'effectivePeriod');
        Vue.delete(this.submitParams.alarmConfig.thresholdConfigs[0], 'dayOfWeeks');
        // return;
        if (this.typeStyle === 'add') {
            createTask(this.submitParams).then((res) => {
                Message.success(this.$t('createdSuccessfully'));
                this.$router.push('/tasklist');
            });
        }
        else if (this.typeStyle === 'copy') {
            this.submitParams.taskId = '';
            createTask(this.submitParams).then((res) => {
                Message.success(this.$t('createdSuccessfully'));
                this.$router.push('/tasklist');
            });
        }
        else {
            if (this.isError && this.formData.taskStatus === 'DISABLE') {
                this.submitParams.taskStatus = 'DISABLE';
            }
            else if (this.isError && this.formData.taskStatus === 'ENABLE') {
                this.submitParams.taskStatus = 'ERROR';
            }
            updateTask(this.submitParams).then((res) => {
                Message.success(this.$t('editSucceeded'));
                this.$router.push('/tasklist');
            });
        }
    }
    // 编辑
    editNotification() {
        this.formData.isEdit = false;
    }
    // 取消编辑
    cancelEdit() {
        this.formData.isEdit = true;
    }
    // 保存编辑
    saveEdit() {
        this.formData.isEdit = true;
        // 提交数据
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    // 获取 roi Polygon 数据
    getPolygonData(val) {
        let data = [];
        this.formData.changeRoi = !this.formData.changeRoi;
        if (val && val.length !== 0) {
            this.tabData[0].complete = true;
            data = val.map((item) => {
                return {
                    rawRoi: {
                        id: this.taskId(),
                        name: item.id,
                        vertices: item.vertices.slice(1),
                    },
                    twinRoi: {
                        id: this.taskId(),
                        name: String(this.taskId()),
                        vertices: [this.twinRoi],
                    },
                };
            });
        }
        else {
            this.tabData[0].complete = false;
        }
        this.dataSource = val;
        this.submitParams.deviceTaskConfigs[0].intrusionConfig.roiMappings = data;
        this.submitParams.deviceTaskConfigs[0].roiData = JSON.stringify(val);
        this.submitParams.deviceTaskConfigs[0].incidentType = 'INCIDENT_INTRUSION';
    }
    mapAddDevice(e) {
        this.formData.changeRoi = !this.formData.changeRoi;
        if (e) {
            this.tabData[1].complete = true;
        }
        else {
            this.tabData[1].complete = false;
        }
        this.twinRoi = e;
        this.submitParams.deviceTaskConfigs[0].intrusionConfig.roiMappings[0].twinRoi = {
            id: this.taskId(),
            name: String(this.taskId()),
            vertices: [e],
        };
    }
    deletePaint(e) { }
    getTaskDetail(id) {
        taskDetail(id).then((res) => {
            let status = '';
            if (res.status === 'ERROR') {
                this.isError = true;
                status = 'ENABLE';
            }
            else {
                status = res.status;
            }
            this.formData.taskStatus = status;
            for (let value of this.tabData) {
                value.complete = true;
            }
            this.formData.remark = res.remark;
            this.formData.isEdit = res.alarmConfig.enable;
            this.submitParams.taskId = String(id);
            this.submitParams.deviceTaskConfigs[0].intrusionConfig.roiMappings = res?.deviceTaskConfigs[0]?.intrusionConfig?.roiMappings;
            this.submitParams.deviceTaskConfigs[0].roiData = res?.deviceTaskConfigs[0]?.roiData;
            this.formData.taskName = res.name;
            this.formData.slectValue = res.bondTaskId ?? '';
            this.formData.alertInterval = res?.alarmConfig?.notifyConfig?.frequency?.value;
            this.formData.deviceId = res?.deviceTaskConfigs[0]?.deviceId;
            this.formData.dateTime = [];
            if (res?.alarmConfig?.thresholdConfigs[0]?.effectiveTimes?.length !== 0) {
                for (let i in res?.alarmConfig?.thresholdConfigs[0]?.effectiveTimes) {
                    this.formData.dateTime.push([
                        res.alarmConfig.thresholdConfigs[0].effectiveTimes[i].start,
                        res.alarmConfig.thresholdConfigs[0].effectiveTimes[i].end,
                    ]);
                }
            }
            if (res?.alarmConfig?.notifyConfig?.enabledAlarmLevels[0] === 'CRITICAL') {
                this.formData.radio = 'critical';
                this.formData.leaveDuration = res.alarmConfig.thresholdConfigs[0].levelConfig.critical;
            }
            else if (res?.alarmConfig?.notifyConfig?.enabledAlarmLevels[0] === 'MAJOR') {
                this.formData.radio = 'major';
                this.formData.leaveDuration = res.alarmConfig.thresholdConfigs[0].levelConfig.major;
            }
            else if (res?.alarmConfig?.notifyConfig?.enabledAlarmLevels[0] === 'MINOR') {
                this.formData.radio = 'minor';
                this.formData.leaveDuration = res.alarmConfig.thresholdConfigs[0].levelConfig.minor;
            }
            this.dataSource = JSON.parse(res.deviceTaskConfigs[0].roiData);
            // this.map
            this.twinRoi = res?.deviceTaskConfigs[0]?.intrusionConfig?.roiMappings[0]?.twinRoi?.vertices[0];
            this.getPolygonData(this.dataSource);
        });
    }
    mounted() {
        const { id, type } = this.$route.query;
        this.typeStyle = String(type);
        if (!isEmpty(type) && type === 'detail') {
            this.isDisabled = true;
        }
        else {
            this.isDisabled = false;
        }
        if (id && id !== '') {
            this.getTaskDetail(id);
        }
        if (this.typeStyle === 'add' || this.typeStyle === 'copy') {
            this.$route.meta.title = 'createStaffDutyleaveTask';
        }
        else if (this.typeStyle === 'detail') {
            this.$route.meta.title = 'detailStaffDutyleaveTask';
        }
        else {
            this.$route.meta.title = 'editStaffDutyleaveTask';
        }
    }
};
__decorate([
    Watch('formData', { immediate: true, deep: true })
], createStaffDutyLeaveTask.prototype, "onChnageFormData", null);
__decorate([
    Watch('formData.deviceId')
], createStaffDutyLeaveTask.prototype, "deviceIdChange", null);
createStaffDutyLeaveTask = __decorate([
    Component({
        name: 'CreateTask',
        components: {
            'roi-area': RoiArea,
            'cascader-select': cascaderSelect,
            'tab-area': TabArea,
            'task-note': TaskNote,
            // equipmentSelection
        },
        i18n: {
            messages: {
                en: {
                    workSchedule: 'Work Schedule',
                    taskName: 'Task Name',
                    taskStatus: 'Activated',
                    camera: 'Camera',
                    roiArea: 'ROI Area',
                    markOnMap: 'Mark on Map',
                    bodyFrame: 'Body Frame',
                    line: 'Line',
                    alertPush: 'Alert Push',
                    notification: 'Notification',
                    threshold: 'Threshold(visitors)',
                    visitor: 'Visitor',
                    optional: 'Connected Task(Optional)',
                    critical: 'Critical',
                    major: 'Major',
                    minor: 'Minor',
                    alertInterval: 'Alert Interval',
                    min: 'Min',
                    edit: 'Edit',
                    cancel: 'Cancel',
                    save: 'Save',
                    pleaseSelect: 'Please select',
                    inputRule: 'No more than 50 characters',
                    start: 'start time',
                    end: 'end time',
                    add: 'add',
                    leaveDuration: 'Leave Duration',
                    timeLog: 'Please fill in the time period',
                    taskNameErr: 'Please enter task name',
                    positiveInteger: 'Please input positive whole number',
                    radioErr: 'Please select the alarm type',
                    deviceErr: 'Please select a device',
                    createdSuccessfully: 'Created Successfully',
                    editSucceeded: 'Edit succeeded',
                    cancelSubmitTip: 'Data will not be saved and exited, are you sure to exit?',
                    know: 'I got it!',
                    tip: 'Tips',
                    confirm: 'Confirm',
                    hasUploadedMap: 'A map has not been uploaded to Area where {camera} resides. Therefore, the task cannot run normally. Please upload the map in map management',
                    hasLinkedMap: 'The task cannot run properly because {camera} has not been added to the map. Go to map management to add the device',
                    status: 'Area where {camera} resides is disabled, and the task cannot run normally. Please enable the area in map management',
                    noVertices: 'has not been punctuated in the map, and the task cannot run normally, please go punctuate this device on map in map management',
                    placeholderTip: 'You can select at least one camera for now',
                },
                zh: {
                    inputRule: '不超过50个字符',
                    taskName: '任务名称',
                    taskStatus: '任务状态',
                    camera: '摄像头',
                    pleaseSelect: '请选择',
                    optional: '连接任务（可选）',
                    critical: '重度',
                    major: '中度',
                    minor: '轻度',
                    start: '开始时间',
                    end: '结束时间',
                    add: '添加',
                    workSchedule: '工作时间表',
                    min: '分钟',
                    alertPush: '告警推送',
                    alertInterval: '告警间隔',
                    leaveDuration: '休假时间',
                    timeLog: '请填写时间段',
                    positiveInteger: '请输入正整数',
                    taskNameErr: '请输入任务名称',
                    radioErr: '请选择告警类型',
                    deviceErr: '请选择设备',
                    createdSuccessfully: '创建成功',
                    editSucceeded: '编辑成功',
                    hasUploadedMap: '{camera} 所在的区域 Check in Area 还未上传地图，任务无法正常运行，请前往地图管理中上传地图',
                    hasLinkedMap: '{camera} 还未在地图中添加，任务无法正常运行，请前往地图管理中添加设备',
                    status: '{camera} 所在的区域 Check in Area 已停用，任务无法正常运行，请前往地图管理中启用该区域',
                    noVertices: '还未在地图中标点，任务无法正常运行，请前往地图管理中标点此设备',
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    know: '我知道了',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    save: '保存',
                    placeholderTip: '您现在至少可以选择一个摄像头',
                },
            },
        },
    })
], createStaffDutyLeaveTask);
export default createStaffDutyLeaveTask;
